import {Component, Input} from '@angular/core';

@Component({
  selector: 'brt-hexagon-icon',
  templateUrl: './hexagon-icon.component.html',
  styleUrls: ['./hexagon-icon.component.scss']
})
export class HexagonIconComponent {
  @Input('active') active = false;
  @Input('quest-mode') questMode = false;
  @Input('step') step: number = 1;
}
